import React, {useState, useEffect, useContext} from "react";
import { Modal, Table } from "antd";
import http from '../../../Http';
import utils from '../../../utils';
import { useTranslation } from 'react-i18next';

function InverterAgilePriceView({open, onOk, onCancel, inverterSN, date}) {
    const { t } = useTranslation();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);

    const setTip = useContext(utils.tipContext);

    const tip = "[InverterAgilePriceView]";

    useEffect(() => {
        let active = true;

        (async () => {
            setLoading(true);
            
            
            let resp = await http.post("inverter-v2/inverter-agile-price/get", { 
                InverterSN: inverterSN,
                Date: date.format('YYYY-MM-DD'),
            }).then(async (r)=>{
                return await r.json();
            }).catch((e)=>{
                console.log(tip, e);
                return null;
            });

            if (! active) {
                return;
            }
            
            if (resp === null || resp.code !== 200) {
                setTip({open:true, severity:"error", msg:(resp && resp.msg) ? resp.msg : t("load data error")});
                
                return;
            }

            const rows = resp.data;
            let rs = [];
            if (rows.length >= 92) {
                let rs_i = [];
                let rs_e = [];
                rows.forEach((item) => {
                    if (item.Direction == "IMPORT") {
                        rs_i.push(item);
                    } else {
                        rs_e.push(item);
                    }
                })
                const half = rs_i.length / 2;
                for (let i = 0; i < half; i++) { 
                    rs.push({
                        Time_01_12: rs_i[i].ValidFrom,
                        Price_01_12: `${rs_i[i].ValueIncVat.toString()} - ${rs_e[i].ValueIncVat.toString()}`,
                        ChargeEnable_01_12: (rs_i[i].Applied == 1),
                        DischargeEnable_01_12: (rs_e[i].Applied == 1),
                        Time_13_24: rs_i[i+half].ValidFrom,
                        Price_13_24: `${rs_i[i+half].ValueIncVat.toString()} - ${rs_e[i+half].ValueIncVat.toString()}`,
                        ChargeEnable_13_24: (rs_i[i+half].Applied == 1),
                        DischargeEnable_13_24: (rs_e[i+half].Applied == 1),
                    });
                }
            }

            setRows( rs);
            setLoading(false);
        })();

        return () => {
            active = false;
        };
    }, [inverterSN, date]);


    return (<Modal 
        title={t("Charge and Discharge with Agile-Price")}
        visible={open} 
        onOk={onOk} 
        onCancel={onCancel} 
        width={"70%"}
        style={{maxWidth: 1200, maxHeight: 600}}
    >
        <Table 
            columns={[{
                title: t('Time'),
                dataIndex: 'Time_01_12',
                width: 180,
            },{
                title: t('Price'),
                dataIndex: 'Price_01_12',
                width: 140,
            },{
                title: t('Charge Enable'),
                dataIndex: 'ChargeEnable_01_12',
                width: 120,
                render: (value) => {
                    return value ? <label style={{color: 'green'}}>✔</label> : "";
                },
            },{
                title: t('Discharge Enable'),
                dataIndex: 'DischargeEnable_01_12',
                width: 120,
                render: (value) => {
                    return value ? <label style={{color: 'green'}}>✔</label> : "";
                },
            },{
                title: t('Time'),
                dataIndex: 'Time_13_24',
                width: 180,
            },{
                title: t('Price'),
                dataIndex: 'Price_13_24',
                width: 140,
            },{
                title: t('Charge Enable'),
                dataIndex: 'ChargeEnable_13_24',
                width: 120,
                render: (value) => {
                    return value ? <label style={{color: 'green'}}>✔</label> : "";
                },
            },{
                title: t('Discharge Enable'),
                dataIndex: 'DischargeEnable_13_24',
                width: 120,
                render: (value) => {
                    return value ? <label style={{color: 'green'}}>✔</label> : "";
                },
            }]}
            tableLayout="fixed"
            bordered={true}
            size="middle"
            loading={loading}
            dataSource={rows}
            pagination={false}
            scroll={{ y: 400 }} 
        />
    </Modal>);
}

export default InverterAgilePriceView;
